import { jsx as _jsx } from "react/jsx-runtime";

/* 
    this component return button to go previous page
*/
import React from "react";
import { handlePreviousPage } from "../../services";
import styles from "./PrevButton.module.scss";

var PrevButton = function PrevButton(_ref) {
  var selected = _ref.selected,
      setSelected = _ref.setSelected,
      onPageChange = _ref.onPageChange,
      previousLabel = _ref.previousLabel;
  //if selected page is first page .we set disbled class to previous button
  var previousClasses = [styles.previous, selected === 0 ? styles.disabled : ""].join(" ");
  return /*#__PURE__*/_jsx("li", {
    className: previousClasses,
    children: /*#__PURE__*/_jsx("a", {
      className: styles.previousLink,
      onClick: function onClick() {
        return handlePreviousPage(selected, setSelected, onPageChange);
      },
      children: /*#__PURE__*/_jsx("img", {
        src: "/images/pagination/arrow right.svg"
      })
    })
  });
};

export default PrevButton;